/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum AvailableFeatureFlags {
    DATA_SET = 'data_set',
    RAPID_DOWNLOAD = 'rapid_download',
    REAL_ASSET = 'real_asset',
    REAL_ASSET_DEPLOYMENT_DETAIL = 'real_asset_deployment_detail',
}
